import React, { Component } from "react";
import { connect } from "react-redux";

import InterviewDetails from "../../../../components/Client/ClientInterviewSchedular/InterviewDetails/InterviewDetails";
import SelectedCandidatesTab from "../../../../components/Client/ClientInterviewSchedular/SelectedCandidatesTab/SelectedCandidatesTab";
import SelectedDateTime from "../../../../components/Client/ClientInterviewSchedular/SelectedDateTime/SelectedDateTime";
import SelectedCandidates from "../../../../components/Client/ClientInterviewSchedular/SelectedCandidates/SelectedCandidates";

import axios from "../../../../services/axios-service";
import "./ClientInterviewDetailsContainer.css";
// import { Link } from "react-router-dom";
import withErrorHandler from "../../../../hoc/withErrorHandler/withErrorHandler";
import ConsoleLog from "../../../../hoc/ConsoleLog/ConsoleLog";
import moment from "moment";
import Icon from "../../../../components/UI/Icon/Icon";
import getS3ImageUrl from "../../../../lib/s3FileHandler";

class ClientInterviewDetailsContainer extends Component {
  state = {
    clientInterviewData: "",
    candidateImageCount: 0
  };
  componentDidMount() {
    let clientId = this.props.location.state.clientId;
    this.fetchScheduledCandidateData(clientId);
  }
  /**
   * @desc fetches the scheduled client details view
   * @param clientId
   * @return null
   */
  fetchScheduledCandidateData = clientId => {
    axios
      .get("/galaxy/interview/" + clientId)
      .then(response => {
        ConsoleLog("response notification", response.data);
        const clientInterviewData = response.data;
        clientInterviewData.candidates.map(candidate => {
          getS3ImageUrl(candidate.candidate_image, this.props.user)
            .then(url => {
              candidate.s3SignedUrl = url;
              this.setState({
                candidateImageCount: this.state.candidateImageCount + 1
              });
            })
            .catch(() => {
              this.setState({
                candidateImageCount: this.state.candidateImageCount + 1
              });
            });
        });
        this.setState({ clientInterviewData });
        // ConsoleLog("scheduler",this.state.interviewScheduledData.interviews,this.state.interviewScheduledData.interviews.length,this.state.interviewScheduledData.progressed)
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });
  };

  render() {
    ConsoleLog("slots", this.state.clientInterviewData.slots);
    const clientInterviewData = this.state.clientInterviewData;
    let candidateSlots = [];
    if (clientInterviewData.slots && clientInterviewData.slots.length > 0) {
      let toDate = "";
      let fromDate = "";
      let durationArray = [];
      candidateSlots = clientInterviewData.slots.map((element, index) => {
        if (clientInterviewData.client_interview_duration === "30 mins") {
          fromDate = moment.utc(element.slot).format("hh:mma");
          toDate = moment
            .utc(element.slot)
            .add(30, "minutes")
            .format("hh:mma");
        } else {
          durationArray = clientInterviewData.client_interview_duration.split(
            " "
          );
          fromDate = moment.utc(element.slot).format("hh:mma");
          toDate = moment
            .utc(element.slot)
            .add(durationArray[0], "hours")
            .format("hh:mma");
        }
        return {
          date: moment.utc(element.slot).format("ddd D MMMM YYYY"),
          time: fromDate + " - " + toDate,
          slotStatus: element.status
        };
      });
    }
    return (
      <div className="interview-view-container">
        <div className="selected-job-title-main">
          <div className="client-interviewview-back">
            <Icon
              icon="left-arrow"
              className="client-interviewview-back-icon "
              onClick={() => {
                this.props.history.push("/interviews");
              }}
            />
            <h1 className="selected-job-title">
              <p>
                Interview scheduler for{" "}
                <span>
                  {this.props.jobTitle}-{this.props.jobTitleBHID}
                </span>
              </p>
            </h1>
          </div>
        </div>
        {clientInterviewData.candidates ? (
          <div className="interview-view-details-section">
            <InterviewDetails
              interviewLocation={clientInterviewData.client_interview_location}
              interviewType={clientInterviewData.client_interview_type}
            />
            {this.state.candidateImageCount ==
            clientInterviewData.candidates.length ? (
              clientInterviewData.client_interview_status === "Pending" ? (
                <div className="client-interview-view-tabs">
                  <SelectedCandidates
                    candidates={
                      this.state.candidateImageCount ==
                      clientInterviewData.candidates.length
                        ? clientInterviewData.candidates
                        : ""
                    }
                  />
                </div>
              ) : (
                <SelectedCandidatesTab
                  candidates={clientInterviewData.candidates}
                  duration={clientInterviewData.client_interview_duration}
                />
              )
            ) : null}
            <SelectedDateTime candidateSlots={candidateSlots} />
            <div className="recruiter-message">
              <h4 className="rec-message-title">Note to your recruiter</h4>
              <p className="rec-message-text">
                {clientInterviewData.client_interview_client_message
                  ? clientInterviewData.client_interview_client_message
                  : "Not Specified"}
              </p>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
/**
 * @desc connecting to redux store
 * @param state
 * @return redux state
 */
const mapStateToProps = state => {
  return {
    // pool: state.talentPool.pool,
    // activeCandidateId: state.talentPool.activeCandidateId,
    // jobTitleId :state.talentPool.jobTitleId,
    // profileInfo: state.candidateProfile.profileInfo,
    // jobs: state.talentPool.jobList,
    user: state.cognito.user,
    // clientDetails: state.clientProfile.clientDetails,
    // companyType:state.talentPool.companyType,
    jobTitle: state.talentPool.jobTitle,
    jobTitleBHID: state.talentPool.jobTitleBHID
  };
};

export default connect(mapStateToProps)(
  withErrorHandler(ClientInterviewDetailsContainer, axios)
);



// WEBPACK FOOTER //
// ./src/container/Client/ClientInterviews/ClientInterviewDetailsContainer/ClientInterviewDetailsContainer.js